import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const rtlLangs = new Set(["ar", "ur", "ckb", "fa", "he", "ku", "prs"]);

export function applyLangAttributes(lang: string) {
    if (typeof document === "undefined") return;
    const html = document.documentElement;
    html.lang = lang;
    const base = lang.toLowerCase();
    const isRtl = Array.from(rtlLangs).some((l) => base.startsWith(l));
    html.dir = isRtl ? "rtl" : "ltr";
}

export const supportedLngs = [
    "en",
    "af",
    "am",
    "ar",
    "bn",
    "bg",
    "my",
    "fr-ca",
    "cs",
    "da",
    "prs",
    "nl",
    "fa",
    "tl",
    "fi",
    "fr",
    "de",
    "el",
    "ga",
    "gu",
    "he",
    "hi",
    "hu",
    "it",
    "ja",
    "ko",
    "ku",
    "ckb",
    "lv",
    "lt",
    "mk",
    "ms",
    "mr",
    "ne",
    "no",
    "pl",
    "pt",
    "pt-br",
    "pa",
    "ro",
    "ru",
    "gd",
    "sk",
    "so",
    "es",
    "sv",
    "sw",
    "th",
    "tr",
    "uk",
    "ur",
    "vi",
    "cy",
    "yo",
    "zh-hans",
    "zh-hant",
];

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        ns: [
            "admin",
            "common",
            "browse",
            "organisations",
            "libraries",
            "messages",
            "resources",
        ],
        defaultNS: "common",
        fallbackLng: "en",
        supportedLngs,
        detection: {
            order: [
                "querystring",
                "localStorage",
                "cookie",
                "navigator",
                "htmlTag",
            ],
            caches: ["localStorage"],
            lookupLocalStorage: "lang",
        },
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
        },
        interpolation: { escapeValue: false },
    })
    .then(() => {
        applyLangAttributes(i18n.language || "en");
        i18n.on("languageChanged", (lng) => applyLangAttributes(lng));
    });

export default i18n;
